import React, { useContext, useState, useEffect } from "react";
import { NormalizedCacheObject } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { useMsal, useAccount } from "@azure/msal-react";
import { ApolloProvider } from "react-apollo";
import { createClient } from "./apolloClient";

export const ApolloProviderWithAuth: React.FC = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [client, setClient] = useState<ApolloClient<
    NormalizedCacheObject
  > | null>(null);

  useEffect(() => {
    if (!account || inProgress != "none") {
      return;
    }

    setClient(createClient(instance, account));
  }, [account, instance]);

  if (!client) return null;
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
